import React, { useEffect, useMemo, useState } from 'react'
import { Button, Card, CardHeader, Col, Container, Row } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import AuthorizeForAction from '../../../Routes/AuthorizeForAction';
import TableContainer from '../../../Components/Common/TableContainer';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import { getExamResults as onGetExamResult } from '../../../slices/result/thunk';
import MyLoader from '../../../common/MyLoader';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import ImageComponent from '../../../common/ImageComponent';
import { api } from '../../../config';
import '../../../assets/custom/results-responsive.css';


function ResultDetailStudent() {

  const dispatch = useDispatch();
  const [resultData, setResultData] = useState([]);
  const [stdData, setStdData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const { attemptId, examType, type } = useParams();
  const navigate = useNavigate();
  const mediaSource = api.IMAGE_URL;

  const selectLayoutState = (state) => state.ResultReducer;

  const resultProperties = createSelector(
    selectLayoutState,
    (data) => ({
      resultList: data.resultList,
      isResultSuccess: data.isResultSuccess,
      error: data.error,
      isResultDetail: data.isResultDetail

    })
  );

  const { resultList, error, isResultSuccess, isResultDetail } = useSelector(resultProperties)

  useEffect(() => {
    i18n.changeLanguage('en');
    if (resultList && resultList.questions && resultList.stdData) {
      setResultData(resultList.questions);
      setStdData(resultList.stdData);
    }
  }, [resultList]);



  useEffect(() => {
    setIsLoading(!isResultDetail);
  }, [isResultDetail]);

  useEffect(() => {
    const postedResultData = {
      attempt_id: attemptId,
      q_lang: 'en'
    };

    dispatch(onGetExamResult(postedResultData));

  }, [dispatch]);

  const resultTableColumns = useMemo(
    () => [
      {
        Header: ("Question"),
        accessor: "question",
        filterable: false,
      },

      {
        Header: "Chosen Answer",
        accessor: "choosed_ans",
        filterable: false,
        Cell: ({ row }) => (
          <ImageComponent
            choosedAns={row.original.choosed_ans}
            imagePath={row.original.choosedImage}
          />
        )
      },

      {
        Header: ("Status"),
        accessor: "q_status",
        Cell: (cell) => {

          var questionClass = "";

          if (cell.value == 'Correct') {
            questionClass = "text-uppercase text-green fw-bold";
          }
          if (cell.value == 'Wrong') {
            questionClass = " text-uppercase  text-danger fw-bold";
          }

          if (cell.value == 'Un-Answered') {
            questionClass = " text-uppercase text-warning fw-bold";
          }

          return (
            <span className={questionClass}>{cell.value}</span>

          );
        },
      },

      {
        Header: "Correct Answer",
        accessor: "correct_ans",
        filterable: false,
        Cell: ({ row }) => (
          <ImageComponent
            choosedAns={row.original.correct_ans}
            imagePath={row.original.correctImage}
          />
        )
      },

    ],

    []
  );

  document.title = "Results|Theory Practice";
  return (
    <React.Fragment>
      <div className="page-content result-detail-page" dir='ltr'>
        <Container fluid className="result-detail-container px-2 px-md-3">
          <Row>
            <Col lg={12}>
              {stdData && stdData.courseShortName == "MCD"  ? (
                <Card className="result-card result-detail-header-card mb-3">
                  <div className="card-body">
                    <div className="rta-results-sheet">
                      <div className="rta-results-header">
                        <div className="rta-results-logo rta-results-logo--left">
                          <img src={mediaSource + 'government-of-dubai-logo.png'} alt="Government of Dubai Logo" />
                        </div>
                        <div className="rta-results-logo rta-results-logo--right">
                          <img src={mediaSource + 'rta_dubai.png'} alt="RTA Logo" />
                        </div>
                      </div>

                      <h3 className="rta-results-title">
                        {t("theory_test_title", {
                          courseName: stdData?.courseName,
                        })}
                      </h3>

                      <div className="result-table-wrap">
                        <table className="rta-detail-table" dir="ltr">
                          <tbody>
                            <tr>
                              <td>{t("Date tested")}:</td>
                              <td>{stdData?.test_date}</td>
                            </tr>
                            <tr>
                              <td>{t("Candidate")}:</td>
                              <td>{stdData?.std_name}</td>
                            </tr>
                            <tr>
                              <td>{t("Candidate ID")}:</td>
                              <td>{stdData?.traffic_id}</td>
                            </tr>
                            <tr>
                              <td>{t("Registration ID")}:</td>
                              <td>{stdData?.traffic_id}</td>
                            </tr>
                            <tr>
                              <td>{t("Exam Series Code")}:</td>
                              <td>{"000-" + stdData?.examId}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </Card>
              ):""}
              <Card className="result-card">
                <CardHeader className="border-0 result-detail-card-header">
                  <Row className="g-3 align-items-center">
                    <Col xs={12} sm>
                      <h5 className="card-title mb-0">Result Detail</h5>
                    </Col>
                    <Col xs={12} sm="auto">
                      {examType == 1 ? (
                        <Button onClick={() => navigate(-1)} color="primary" className="result-detail-back-btn">Back</Button>
                      ) : (
                        <Link to="/admin/practice-result">
                          <Button type="button" color="success" className="result-detail-back-btn">Back</Button>
                        </Link>
                      )}
                    </Col>
                  </Row>
                </CardHeader>
                <div className="card-body pt-0">
                  <div>
                    <div>

                      {
                        isLoading ?
                          <MyLoader />
                          :
                          <>
                            {resultData.length > 0 ? (
                              <TableContainer
                                columns={resultTableColumns}
                                data={(resultData || [])}
                                customPageSize={1000}
                                className="custom-header-css align-middle result-detail-table"
                                divClass="table-responsive result-detail-table-wrap"
                              />
                            ) : (
                              <div className="py-4 text-center">
                                <div>
                                  <lord-icon
                                    src="https://cdn.lordicon.com/msoeawqm.json"
                                    trigger="loop"
                                    colors="primary:#405189,secondary:#0ab39c"
                                    style={{ width: "72px", height: "72px" }}
                                  ></lord-icon>
                                </div>

                                <div className="mt-4">
                                  <h5>Sorry! No Record Found</h5>
                                </div>
                              </div>
                            )
                            }
                          </>
                      }
                    </div>


                  </div>
                  {/* <ToastContainer closeButton={false} limit={1} /> */}
                </div>

              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ResultDetailStudent